<template>
    <standard-modal
        :name="name"
        :show-close-button="true"
    >
        <div class="text-center">
            <div style="font-size: 50px;">😢</div>
            <h2 class="headline-2xl mt-sm">{{ lang('Oops!','Oops!') }}</h2>
            <div class="text-neutral-dark font-bold my-2xl">
                {{ error }}
            </div>
            <ul
                v-if="validationErrors"
                class="list-reset mt-lg block"
            >
                <li v-for="validationError in validationErrors">
                    {{ validationError[0] }}
                </li>
            </ul>
            <button class="btn btn-md is-primary mb-xl" @click="close">{{ lang('Stäng','Close') }}</button>
        </div>
    </standard-modal>
</template>
<script>
    export default {
        props: {
            name: {
                type: String,
                required: false,
                default: 'error-modal',
            },
            error: {
                type: String,
                required: false,
                default: '',
            },
            validationErrors: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            onCloseCallback: {
                type: Function,
                default: null,
            },
        },
        methods: {
            close() {
                this.$modal.hide(this.name);

                if (this.onCloseCallback !== null) {
                    this.onCloseCallback();
                }
            },
        },
    };
</script>
